// extracted by mini-css-extract-plugin
export default {"mainHeaderContainer":"headerComponent_mainHeaderContainer__jiqw+","innerContainer":"headerComponent_innerContainer__B25R7","signInBtn":"headerComponent_signInBtn__ft2Bl"};